import React, { useState } from "react";
import { loginUsers } from "../../api/users";
import { useNavigate } from 'react-router-dom';

function SignInForm() {
	const [state, setState] = React.useState({
		email: "",
		password: ""
	});

  	const navigate = useNavigate();

	const handleChange = evt => {
		const value = evt.target.value;
		setState({
			...state,
			[evt.target.name]: value
		});
	};

	const handleOnSubmit = async  (evt) => {
		evt.preventDefault();
		const { email, password } = state;
		const res = await  loginUsers(email, password)
		console.log(res);
		if(res.status !== "success"){
			alert('Authentification failed')
		}else{
			localStorage.setItem('user_id', res.data['id'])
			localStorage.setItem('token', res.token)
			localStorage.setItem('email', res.data['email'])
			localStorage.setItem('fonction_id', res.data['fonction_id'])
			localStorage.setItem('nom', res.data['nom'])
			localStorage.setItem('prenom', res.data['prenom'])
			localStorage.setItem('permissions', JSON.stringify(res.data['permissions']))
			localStorage.setItem('agence_id', res.data['agence_id'])
			navigate('/acceuil')
		}
	};

	return (
		<div className="form-container sign-in-container">
			<form onSubmit={handleOnSubmit}>
				<h1>Sign in</h1>
				<input
					type="email"
					placeholder="Email"
					name="email"
					value={state.email}
					onChange={handleChange}
				/>
				<input
					required
					type="password"
					name="password"
					placeholder="Password"
					value={state.password}
					onChange={handleChange}
				/>
				<a href="#">Forgot your password?</a>
				<button>Sign In</button>
			</form>
		</div>
	);
}

export default SignInForm;
